// import React from "react";
// import { useTranslation } from "react-i18next";
// import { useFontStyle } from "~/hook/useFontStyle";
// import { categoryAndAutherProps } from "~/interface/article/article";
// import { cn } from "~/lib/utils";
// import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger } from "../ui/select";

// function SelectArticleType({
//   categoryArray,
//   placeHolder,
//   setSelectedValue,
//   selectedValue,
// }: {
//   categoryArray: categoryAndAutherProps[];
//   placeHolder: string;
//   setSelectedValue: (selected: { value: string; id: number }) => void;
//   selectedValue: number | null;
// }) {
//   const { medium, mediumInter } = useFontStyle();
//   const { t } = useTranslation();

//   const selectedCategoryName = categoryArray.find((category) => category.id === selectedValue)?.text || placeHolder;
//   return (
//     <Select
//       value={categoryArray.find((category) => category.id === selectedValue)?.text}
//       onValueChange={(value) => {
//         if (value === "clear") {
//           setSelectedValue({ value: "clear", id: 0 });
//         } else {
//           const selectedCategory = categoryArray.find((category) => category.text === value);
//           if (selectedCategory) {
//             setSelectedValue({ value: selectedCategory.text, id: selectedCategory.id });
//           }
//         }
//       }}
//     >
//       <SelectTrigger className="w-[180px] rounded-full !bg-secondaryColor border-none py-3 2xl:py-6 px-3 shadow-none">
//         <span className={cn("!text-textColor body_text_m line-clamp-1 truncate w-full", medium)} title={selectedCategoryName}>
//           {selectedCategoryName}
//         </span>
//       </SelectTrigger>
//       <SelectContent>
//         <SelectGroup>
//           <SelectItem className={cn("!text-textColor body_text_s cursor-pointer", mediumInter)} value={"clear"}>
//             {t("blog.clearFilter", { defaultValue: "Clear Filter" })}
//           </SelectItem>
//           {categoryArray.map((category) => (
//             <React.Fragment key={category.id}>
//               <SelectItem
//                 value={category.text}
//                 className={cn("text-textColor rounded-none hover:!bg-secondaryColor cursor-pointer capitalize body_text_s", mediumInter)}
//               >
//                 {category.text}
//               </SelectItem>
//             </React.Fragment>
//           ))}
//         </SelectGroup>
//       </SelectContent>
//     </Select>
//   );
// }

// export default SelectArticleType;

import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";
import ReactSelect, { components, DropdownIndicatorProps } from "react-select";
import { useFontStyle } from "~/hook/useFontStyle";
import { categoryAndAutherProps } from "~/interface/article/article";
import { cn } from "~/lib/utils";

type OptionType = { label: string; value: string; id: number };

const DropdownIndicator = (props: DropdownIndicatorProps<OptionType>) => (
  <components.DropdownIndicator {...props}>
    <ChevronDown className="w-5 h-5 text-textColor" strokeWidth={2} />
  </components.DropdownIndicator>
);

function SelectArticleType({
  categoryArray,
  placeHolder,
  setSelectedValue,
  selectedValue,
}: {
  categoryArray: categoryAndAutherProps[];
  placeHolder: string;
  setSelectedValue: (selected: { value: string; id: number }) => void;
  selectedValue: number | null;
}) {
  const { medium, mediumInter } = useFontStyle();
  const { t } = useTranslation();

  const clearOption: OptionType = {
    label: t("blog.clearFilter", { defaultValue: "Clear Filter" }),
    value: "clear",
    id: 0,
  };

  const categoryOptions: OptionType[] = categoryArray.map((category) => ({
    label: category.text,
    value: category.text,
    id: category.id,
  }));

  const options: OptionType[] = [clearOption, ...categoryOptions];

  const selected = categoryOptions.find((opt) => opt.id === selectedValue) ?? null;

  const handleChange = (option: OptionType | null) => {
    if (!option || option.value === "clear") {
      setSelectedValue({ value: "clear", id: 0 });
    } else {
      setSelectedValue({ value: option.value, id: option.id });
    }
  };

  return (
    <ReactSelect<OptionType>
      options={options}
      value={selected}
      onChange={handleChange}
      placeholder={placeHolder}
      isSearchable={false}
      className="w-[200px] !text-center"
      components={{ DropdownIndicator, IndicatorSeparator: () => null }}
      classNames={{
        control: () => cn("!bg-secondaryColor !rounded-full !border-none !shadow-none !min-h-[42px] !px-3 hover:!bg-secondaryColor", medium),
        valueContainer: () => "!px-0",
        input: () => cn("!text-textColor body_text_m", medium),
        singleValue: () => cn("!text-textColor body_text_m", medium),
        placeholder: () => cn("!text-textColor body_text_m", medium),
        dropdownIndicator: () => "!p-0 pr-1 text-textColor",
        menu: () => "!bg-secondaryColor !rounded-2xl !border !border-borderPrimary !shadow-none overflow-hidden",
        menuList: () => "p-1 max-h-60 overflow-y-auto custom-scrollbar text-textColor",
        option: ({ isFocused, isSelected }) =>
          cn(
            "!cursor-pointer !text-start capitalize body_text_s  leading-7 !rounded-xl !px-3 !py-2 !line-clamp-2 !whitespace-normal",
            mediumInter,
            isFocused && "!bg-secondaryBackground",
            isSelected ? "!bg-primary !text-textColor" : "!text-textColor",
          ),
      }}
    />
  );
}

export default SelectArticleType;
